module.exports = __webpack_public_path__ + "media/images/homelessness-graph-6f82fcc063139bc37f38f3afba760447.png";